const ja = {
    '例子': '例文',
}
export default ja;